import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PayService } from 'src/app/models/pay-service';
import { ServiceService } from 'src/app/services/service.service';

@Component({
  selector: 'app-service-calendar',
  templateUrl: './service-calendar.component.html',
  styleUrls: ['./service-calendar.component.css']
})
export class ServiceCalendarComponent implements OnInit {

  loading:boolean = false;
  pay_services:PayService[] = [];
  pay_service:PayService = new PayService();
  events:any[];
  controls:any;

  constructor(private serviceServ:ServiceService, private modalService: NgbModal) { }

  ngOnInit() {
    this.loading = true;
    this.controls = {
      left: 'dayGridMonth,timeGridWeek,timeGridDay',
      center: 'title',
      right: 'today prevYear,prev,next,nextYear',
    };
    this.serviceServ.getPayServices().subscribe(pay_services=>{
      this.pay_services = pay_services.filter(pay=> pay.notification_days );
      let events = [];
      this.pay_services.forEach(pay_service=>{
        events.push({
          title: pay_service.unity_id + ' - ' + pay_service.service_type.description + ' - ' + pay_service.unity.unit_type.name,
          start: pay_service.initial_date,
          backgroundColor: this.getColor('bg-color', 'initial'),
          borderColor: this.getColor('bg-color', 'initial'),
          textColor: this.getColor('color'),
          extendedProps: pay_service,
          editable: false,
          display: 'auto',
        });
        events.push({
          title: pay_service.unity_id + ' - ' + pay_service.service_type.description + ' - ' + pay_service.unity.unit_type.name,
          start: pay_service.final_date,
          backgroundColor: this.getColor('bg-color', 'final'),
          borderColor: this.getColor('bg-color', 'final'),
          textColor: this.getColor('color'),
          extendedProps: pay_service,
          editable: false,
          display: 'auto',
        });
      });
      this.events = events;
      this.loading = false;
    },error=>{
      this.loading = false;
    });
  }

  getColor(property, position = null){
    switch (property) {
      case 'bg-color':
        switch (position) {
          case 'initial':
            return '#c3e6cb';
          case 'final':
            return '#f5c6cb';
        }
      case 'color':
        return '#000000';
    }
  }

  showDetail(pay_service, modal){
    this.pay_service = pay_service;
    this.modalService.open(modal, { size: 'lg', centered: true });
  }
}
